import React, { useEffect, useState } from 'react';
import { Trash2, MailOpen, Mail, Phone } from 'lucide-react';
import api from '../../lib/api';

export default function AdminFranchise() {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);
  const load = () => api.get('/admin/franchise').then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const markRead = async (m) => { await api.post(`/admin/franchise/${m.id}/read`); load(); };
  const del = async (m) => { if (!window.confirm('Delete this inquiry?')) return; await api.delete(`/admin/franchise/${m.id}`); setSelected(null); load(); };

  return (
    <div>
      <h1 className="font-heading font-bold text-3xl text-[#0F1C2E] mb-6">Franchise Inquiries</h1>
      <div className="grid lg:grid-cols-[380px_1fr] gap-6">
        <div className="bg-white rounded-2xl shadow-sm overflow-hidden max-h-[70vh] overflow-y-auto">
          {items.length === 0 ? <div className="p-8 text-center text-gray-400 text-sm">No inquiries yet</div> : items.map((m) => (
            <button key={m.id} onClick={() => { setSelected(m); if (!m.read) markRead(m); }} className={`w-full text-left px-5 py-4 border-b border-gray-50 hover:bg-[#FDF3EC] ${selected?.id === m.id ? 'bg-[#FDF3EC]' : ''}`}>
              <div className="flex items-center gap-2 mb-1">
                {m.read ? <MailOpen size={14} className="text-gray-400" /> : <Mail size={14} className="text-[#ED2E2E]" />}
                <span className={`font-semibold text-sm ${m.read ? 'text-gray-600' : 'text-[#0F1C2E]'}`}>{m.firstName} {m.lastName}</span>
              </div>
              <div className="text-xs text-gray-500 truncate">{m.city} → {m.desired}</div>
              <div className="text-xs text-gray-400 mt-1">{new Date(m.created_at).toLocaleString()}</div>
            </button>
          ))}
        </div>

        <div className="bg-white rounded-2xl shadow-sm p-8">
          {!selected ? <div className="text-center text-gray-400 py-16">Select an inquiry</div> : (
            <div>
              <div className="flex items-start justify-between mb-6">
                <h2 className="font-heading font-bold text-2xl text-[#0F1C2E]">{selected.firstName} {selected.lastName}</h2>
                <button onClick={() => del(selected)} className="p-2 hover:bg-red-50 text-gray-400 hover:text-red-500 rounded-lg"><Trash2 size={18} /></button>
              </div>
              <div className="grid sm:grid-cols-2 gap-4 mb-6 text-sm">
                <Detail label="Email" value={<a href={`mailto:${selected.email}`} className="text-[#ED2E2E]">{selected.email}</a>} />
                <Detail label="Phone" value={<a href={`tel:${selected.phone}`} className="text-[#ED2E2E]">{selected.phone}</a>} />
                <Detail label="Current City" value={selected.city} />
                <Detail label="Desired Location" value={selected.desired} />
                <Detail label="Timeframe" value={selected.timeframe} />
                <Detail label="Budget" value={selected.budget} />
                <Detail label="Owned business?" value={selected.experience} />
              </div>
              {selected.experienceDetail && <div className="mb-4"><div className="text-xs font-semibold text-gray-500 uppercase mb-1">Experience Detail</div><p className="text-gray-800 whitespace-pre-wrap">{selected.experienceDetail}</p></div>}
              {selected.interest && <div className="bg-[#FDF3EC] rounded-2xl p-6"><div className="text-xs font-semibold text-gray-500 uppercase mb-2">Interest</div><p className="text-gray-800 whitespace-pre-wrap">{selected.interest}</p></div>}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function Detail({ label, value }) {
  return <div><div className="text-xs font-semibold text-gray-500 uppercase mb-0.5">{label}</div><div className="text-gray-800">{value}</div></div>;
}
